import { securityTips } from '@/mocks/home';

export default function SecuritySection() {
  return (
    <section id="security" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 bg-accent-100 px-3 py-1.5 rounded-full">
            <i className="ri-shield-check-line"></i>
            安全提示
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            六条值得长期记住的浏览习惯
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            安全不是一次性的检查，而是习惯的累积。下面六条并不复杂，但只要坚持下去，
            就能显著降低误入仿冒页面、泄露账号信息的概率。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {securityTips.map((tip) => (
            <div
              key={tip.title}
              className="rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-accent-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}